import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/auth-context';
import { projectActions, writeStoredProject } from '../../store/project';

/**
 * Returns openProject(project): selects a bid's linked project, remembers it,
 * and opens its Workflow page — which switches the sidebar to Projects mode
 * (ticket #295, plan §4.11). `project` is the bid's { id, number, name,
 * defaultTradeId }.
 */
export function useOpenLinkedProject() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  return useCallback(
    (project) => {
      const payload = {
        id: project.id,
        number: project.number,
        name: project.name,
        default_trade_id: project.defaultTradeId ?? null,
      };
      dispatch(projectActions.selectProject(payload));
      writeStoredProject(userId, payload);
      navigate('/package-workflow');
    },
    [dispatch, navigate, userId]
  );
}

export default useOpenLinkedProject;
